
















































































































import { defineComponent, toRefs } from '@vue/composition-api';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppInput from '@berlin-front/common/components/elements/AppInput';
import AppInputMail from '@berlin-front/common/components/elements/AppInputMail';
import AppLink from '@berlin-front/common/components/elements/AppLink';
import AppProgressBar from '@berlin-front/common/components/elements/AppProgressBar';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppCheckbox from '@berlin-front/common/components/elements/AppCheckbox';
import AtoneAlert from '@berlin-front/common/components/atone-components/AtoneAlert';

import FlashMessage from '@berlin-front/common/components/clusters/FlashMessage';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';

import { useContext } from '@berlin-front/common/composables/context';
import { ALERT_TYPE } from '@berlin-front/common/components/atone-components/AtoneAlert/composable';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { ModalBridgeContext } from '@services/ModalBridgeContext';
import { LINE_HEIGHT, TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';

import { HEIGHT_TYPE } from '@berlin-front/common/components/elements/AppProgressBar/composable';
import { ROUTE_NAME } from '@/router/route-name';
import { LiteLoginGuestContext } from './composable';

const ATONE_LITE_TERMS_OF_USE_URL = process.env.VUE_APP_ATONE_LITE_TERMS_OF_USE_URL;
export default defineComponent({
  name: 'AtoneLoginView',
  components: {
    AppButton,
    AppCard,
    AppContainer,
    AppInput,
    AppInputMail,
    AppProgressBar,
    AppRow,
    AppText,
    AppLink,
    FlashMessage,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
    AppCheckbox,
    AtoneAlert,
  },

  setup() {
    const { useLiteAuthLoginGuest } = useContext(LiteLoginGuestContext);
    const bridge = useContext(ModalBridgeContext);
    const {
      state,
      progress,
      progressIsLoading,
      v$,
      messages,
      normalize,
      showMessageToNpLogin,
      showMessageToAtoneLogin,
      getError,
      termsConsentCheck,
      submitButtonDisabled,
      onSubmit,
      resurrectionFaq,
      withdrawErrorFlag,
      guestWithdrawErrorFlag,
    } = toRefs(useLiteAuthLoginGuest());

    const showHelp = () => {
      if (progressIsLoading.value) return;
      bridge.showHelp();
    };

    return {
      ALERT_TYPE,
      // 状態
      state,

      // 表示項目
      messages,

      termsConsentCheck,
      submitButtonDisabled,

      // // 関数
      normalize,
      onSubmit,
      showMessageToNpLogin,
      showMessageToAtoneLogin,
      showHelp,

      // 定数値
      HEIGHT_TYPE,
      TEXT_SIZE,
      TEXT_WEIGHT,
      ROUTE_NAME,
      ATONE_LITE_TERMS_OF_USE_URL,
      LINE_HEIGHT,
      resurrectionFaq,
      HEADER_TYPE,

      // progress
      progress,
      progressIsLoading,

      // validator
      v$,
      getError,
      withdrawErrorFlag,
      guestWithdrawErrorFlag,
    };
  },
});
